import { AsyncStates } from "src/constants";

export const STORE_ACTION_INITIAL_DATA = {
  status: AsyncStates.INITIAL,
  data: "",
  error: "",
  message: "",
};
